export default "__VITE_ASSET__Bd$FeXfm__"